<template>
  <div
    class="tw-flex tw-items-center tw-justify-center"
    :class="{
      'tw-space-x-4': buttons.length > 1 && !stacked,
      'tw-space-y-2': buttons.length > 1 && stacked,
      'tw-flex-col': stacked,
    }"
  >
    <a
      v-for="button in buttons"
      class="jwb-button orange tw-mt-0 tw-mb-4"
      :href="button.link.url"
      target="_blank"
      >{{ button.link.title }}</a
    >
  </div>
</template>

<script>
export default {
  props: {
    buttons: { type: Array, default: () => [] },
    stacked: { type: Boolean, default: true },
  },
}
</script>
